import React, { useState } from 'react';
import { FaEnvelope, FaPhone, FaLinkedin, FaRegCopy } from 'react-icons/fa';
import '../styles/contact.css';
import '../styles/sections.css';

export const Contact = () => {
  const [copiedField, setCopiedField] = useState(null);

  const handleCopy = (text, field) => {
    navigator.clipboard.writeText(text);
    setCopiedField(field);
    setTimeout(() => setCopiedField(null), 2000);
  };

  return (
    <div className="contact-section">
      <div className="section-header">
        <h2>CONTACT ME</h2>
        <div className="underline"></div>
      </div>

      <div className="contact-content-wrapper centered-contact">
        <div className="contact-content">
          {/* Email Copy Box */}
          <div className="copy-box">
            <FaEnvelope style={{ fontSize: '1.2rem', marginRight: '8px' }} />
            <span>karstenhedrick@icloud.com</span>
            <button onClick={() => handleCopy('karstenhedrick@icloud.com', 'email')} className="copy-button">
              <FaRegCopy />
              <span className="copy-tooltip">{copiedField === 'email' ? 'Copied!' : 'Copy'}</span>
            </button>
          </div>

          {/* Phone Copy Box */}
          <div className="copy-box">
            <FaPhone style={{ fontSize: '1.2rem', marginRight: '8px' }} />
            <span>(602) 541-5166</span>
            <button onClick={() => handleCopy('(602) 541-5166', 'phone')} className="copy-button">
              <FaRegCopy />
              <span className="copy-tooltip">{copiedField === 'phone' ? 'Copied!' : 'Copy'}</span>
            </button>
          </div>

          {/* LinkedIn */}
          <p>
            <FaLinkedin style={{ fontSize: '1.2rem', marginRight: '8px' }} />
            <a
              href="https://www.linkedin.com/in/karstenhedrick/"
              target="_blank"
              rel="noreferrer"
            >
              linkedin.com/in/karstenhedrick
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
